/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdatePromptTemplateForm,
  UpdatePromptTemplateForm$Outbound,
  UpdatePromptTemplateForm$outboundSchema,
} from "../components/updateprompttemplateform.js";

export type UpdateTemplateSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UpdateTemplateSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UpdateTemplateSecurity = {
  option1?: UpdateTemplateSecurityOption1 | undefined;
  option2?: UpdateTemplateSecurityOption2 | undefined;
};

export type UpdateTemplateRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updatePromptTemplateForm: UpdatePromptTemplateForm;
};

/** @internal */
export type UpdateTemplateSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UpdateTemplateSecurityOption1$outboundSchema: z.ZodMiniType<
  UpdateTemplateSecurityOption1$Outbound,
  UpdateTemplateSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateTemplateSecurityOption1ToJSON(
  updateTemplateSecurityOption1: UpdateTemplateSecurityOption1,
): string {
  return JSON.stringify(
    UpdateTemplateSecurityOption1$outboundSchema.parse(
      updateTemplateSecurityOption1,
    ),
  );
}

/** @internal */
export type UpdateTemplateSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UpdateTemplateSecurityOption2$outboundSchema: z.ZodMiniType<
  UpdateTemplateSecurityOption2$Outbound,
  UpdateTemplateSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function updateTemplateSecurityOption2ToJSON(
  updateTemplateSecurityOption2: UpdateTemplateSecurityOption2,
): string {
  return JSON.stringify(
    UpdateTemplateSecurityOption2$outboundSchema.parse(
      updateTemplateSecurityOption2,
    ),
  );
}

/** @internal */
export type UpdateTemplateSecurity$Outbound = {
  Option1?: UpdateTemplateSecurityOption1$Outbound | undefined;
  Option2?: UpdateTemplateSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UpdateTemplateSecurity$outboundSchema: z.ZodMiniType<
  UpdateTemplateSecurity$Outbound,
  UpdateTemplateSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UpdateTemplateSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UpdateTemplateSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function updateTemplateSecurityToJSON(
  updateTemplateSecurity: UpdateTemplateSecurity,
): string {
  return JSON.stringify(
    UpdateTemplateSecurity$outboundSchema.parse(updateTemplateSecurity),
  );
}

/** @internal */
export type UpdateTemplateRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdatePromptTemplateForm: UpdatePromptTemplateForm$Outbound;
};

/** @internal */
export const UpdateTemplateRequest$outboundSchema: z.ZodMiniType<
  UpdateTemplateRequest$Outbound,
  UpdateTemplateRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updatePromptTemplateForm: UpdatePromptTemplateForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      updatePromptTemplateForm: "UpdatePromptTemplateForm",
    });
  }),
);

export function updateTemplateRequestToJSON(
  updateTemplateRequest: UpdateTemplateRequest,
): string {
  return JSON.stringify(
    UpdateTemplateRequest$outboundSchema.parse(updateTemplateRequest),
  );
}
